module.exports = __webpack_public_path__ + "img/planetary-rev00.59cf5b6e.jpg";